


































	import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLList extends Vue {
		@Prop({ type: String, required: true, default: "" }) label?: string; //hlavní popis
		@Prop({ type: String, required: false, default: "6" }) labelWidth?: string; //šířka
		@Prop({ type: String, required: false, default: "6" }) inputWidth?: string; //širka druheho
		@Prop({ required: true }) items: any; //mapovani list/ nebo jeden prvek
		@Prop({ type: Boolean, required: false, default: false }) onlyOne?: boolean; //pouze jeden prvek
		@Prop({ type: String, required: false, default: "addLeft0" }) design!: string; //upravny design pro onlyOne

        @Prop({ type: Boolean, required: false, default: true }) addColon?: boolean; //pridani dvoutecky za nazev 

		name() {
			return this.items == null ? '' : this.items.name;
		}

		labelPrepare() {
			return this.addColon == true ? this.label + ":" : this.label;
		}

		get inputClassOne() {
			return {
				"labelDetailFormLinkOnlyOne": true,
				"helpPaddingLeft10": this.design == 'addLeft'
			};
		}

		addStyle() {
			var left = this.design.replace("addLeft", "");
			var styleAdd = "padding-left:" + left + "px";
			return styleAdd;
		}

		//načtení stylu
		get inputClass(){
			return {			
				"labelDetailFormHead": true
			};
		}

		goToDetail(item: any): void {
			this.$emit('selectItem', item);
		}

	

	}
